import _ from 'lodash';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { LabelChoice } from '@scale/shared/types/params/annotation';
import HintTooltipIcon from '../../tasks/textcollection/HintTooltipIcon';
import { Checkbox } from 'design-system';
import { makeStyles } from 'design-system/product/theme';

interface AttributeCheckboxInputProps {
  choice: LabelChoice;
  selected?: boolean;
  isReadOnly?: boolean;
  instructionItem?: string;
  legendColor?: string;
  handleSelect?: (choice: string) => void;
  hints?: { [label: string]: string };
}

export default function AttributeCheckboxInput({
  choice,
  selected,
  isReadOnly,
  instructionItem,
  legendColor,
  handleSelect,
}: AttributeCheckboxInputProps) {
  let choiceValue: string;
  let choiceDisplay: string;
  let choiceHint: string | undefined;
  if (_.isString(choice)) {
    choiceValue = choice;
    choiceDisplay = choice;
    choiceHint = undefined;
  } else {
    choiceValue = choice.choice;
    choiceDisplay = choice.display || choice.choice;
    choiceHint = choice.hint;
  }

  const onClick = () => {
    if (handleSelect && !isReadOnly) {
      handleSelect(choiceValue);
    }
  };

  const styles = useStyles();

  return (
    <div
      className={styles.container}
      onClick={onClick}
      data-tip={instructionItem}
      data-for="label-description"
      data-place="left"
      data-multiline={true}
    >
      <Checkbox
        label={''}
        checked={selected}
        disabled={isReadOnly}
        classes={{ checkboxRoot: styles.checkboxRoot }}
      ></Checkbox>
      <div className={styles.label}>
        {choiceDisplay}
        {choiceHint && <HintTooltipIcon key={choiceValue} hint={choiceHint} />}{' '}
        {legendColor ? (
          <span className={styles.legend} style={{ background: legendColor }} />
        ) : null}
      </div>
      <ReactTooltip id="label-description" />
    </div>
  );
}

const useStyles = makeStyles(() => ({
  container: {
    padding: '2px',
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.2s',
    cursor: 'pointer !important',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.05)',
    },
  },
  label: {
    color: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    flexDirection: 'row',
  },
  legend: {
    marginLeft: '4px',
    display: 'inline-block',
    height: '14px',
    width: '14px',
    borderRadius: '2px',
  },
  checkboxRoot: {
    paddingLeft: '0px',
    paddingRight: '6px',
    paddingTop: '3px',
    paddingBottom: '3px',
  },
}));
